<template>
    <div class="pop-body-hd bg_white flex_layout flex_y_center flex_x_spacebetween">
        <div class="flex_layout flex_xy_center">
          <div class="ico-head">
            <img :src="avatar_url"/>
        </div>
          <span>{{ nickname }}</span>
          <div class="ico-level">
            <img :src="vip_big_icon"/>
        </div>
        </div>
        <i @click="clickClosePop"></i>
    </div>
</template>
<script>
    export default {
        name: 'InfoUser',
            data () {
            return {
            }
        },
        props: {
            visible:{
                type: Boolean,
                default :false,
            },
            value:{
                type: Object,
                default () {
                    return {
                        user : {},
                        vip_user : {},
                    }
                }
            },
        },
        computed: {
            //头像
            avatar_url() {
                let {user={}} = this.value;
                return user.avatar_url;
            },
            //昵称
            nickname() {
                let {user={}} = this.value;
                return user.nickname;
            },
            //是否有充值记录
            has_charge_record() {
                let {vip_user={}} = this.value;
                return vip_user.has_charge_record ? vip_user.has_charge_record : false;
            },
            //是否是会员,大于0表示是会员，0表示非会员
            vip_type() {
                let {vip_user={}} = this.value;
                return vip_user.vip_type ? vip_user.vip_type: 0;
            },
            //会员剩余时间，单位为ms，负数时表示已过期的时间
            remained_time() {
                let {vip_user={}} = this.value;
                return vip_user.remained_time ? vip_user.remained_time : 0;
            },
            //会员分组名称
            vip_group_type_name() {
                let {vip_user={}} = this.value;
                return vip_user.vip_group_type_name ? vip_user.vip_group_type_name : "";
            },
            //会员等级icon
            vip_big_icon() {
                let {vip_user={}} = this.value;
                return vip_user.vip_big_icon;
            },
        },
        created() {
            
        },
        methods:{
            clickClosePop() {
                this.$emit('res', '');
            },
        },
    }
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.pop-body-hd{
    padding:0 vws(20px);height:vws(84px);border-radius: vws(20px) vws(20px) 0 0;
    .ico-head{
        border-radius: 50%;width:vws(40px);height:vws(40px);overflow: hidden;
    }
    span{
        font-family: PingFangSC-Regular;padding:0 vws(4px) 0 vws(8px);font-size: vws(28px);color:#333;
    }
    .ico-level{
        width:vws(57px);height:vws(34px);overflow: hidden;
    }
    i{
        display:inline-block;width:vws(52px);height:vws(52px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAAAilBMVEX///8AAAD6+fl2Z2j///////9gTk+Wiovp5+f///////////////////////////////////////////////////////////////////////////////////////////9/cHKckpOlm5zHwMH///9LNzlnVVeRhYaupaa5sbLW0tLn5ORUQUNKNjgT5uPkAAAALXRSTlPMAM3xwpn359G0ioAaC8i9qKGDe3RcV01LQjwmIBUTB+7l49mm/vXo4N3V0fvkAk6dAAACM0lEQVRYw6zSiW6CQBSF4YPOaIdFFpF9c2mTNpn3f72iXRCV4QLzP8CXk9wLYyw7O+y5J9zdzhUe3x8y2xhLjZaJJfCUsJJyLurEHIPx2JmBFhaDMmYVE9HcBCEzn4BWAYgFFRWNGMixiITaPibl2+NoyjAxlo6hIWYUKtHaxKzMehh1OGbGnSHUuWB2F+c1WnMsiNcvUROLMl+hIRYWPqMpFpc+ojbD4pj9gPrQkN9HI2gpukcrBi2x6g4NoKmgQ3NoK/9HTWjL/EMLaKz4RS1ozPpBHQaNMeeGxtBafEM5hjufznjq6/S5wmD8ipYKs5FSNo/A8V3KD4Vatmii2CmvrfvAVl47YrDEgOr2J9mpfVM2qvvDEOqlndqZ6qXCgA1FTaf2zc0Kw9nIoGi17tSe+QZFGQ4gqmSzJfegqlSzJTmoKtUEhweqSjVbUoCm0k0IuKCpdLMld6CpdBM7Eoqt7H6AgrpUk666EFSTrgp4VJOueuBUc/PdnLnjMAgDQXTjyFKKdIiGChcJ5HP/81GucDEaIT2BD/BK78ybu0utMbjMR3GpQ4wuM8KljjHZTJs66U+6JTP21BDvKc/J95XMjrqqc2IcvmQmVR4+faI/yeypizjROkyUdzL31P9Ph4lbFdQ2txL9W+dFMCsS0JAoSYReJJ4TRQKpPEQ5Q2okUXiJao5IBEJ3EGKGUEiI7CK0HCEQCdUJSFlCHxOiG1DyxHgAzBznDzLOdHSdkev4HLcBcwpUk13c1S4AAAAASUVORK5CYII=") no-repeat 0 0;background-size: 100% 100%;
    }
}
</style>



// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/comp/InfoUser.vue